module.exports = __webpack_public_path__ + "static/murdoch-uni-case-study-video-79869eef3494ba9074cc9e6c38601483.mp4";